import type {
    OrderChangeRefundRequestedEvent} from "./order-change-refund-requested.event";
import {
    isOrderChangeRefundRequestedEvent,
} from "./order-change-refund-requested.event";
import type {
    OrderFullRefundRequestedEvent} from "./order-full-refund-requested.event";
import {
    isOrderFullRefundRequestedEvent,
} from "./order-full-refund-requested.event";
import type {
    OrderPartialRefundRequestedEvent} from "./order-partial-refund-requested.event";
import {
    isOrderPartialRefundRequestedEvent,
} from "./order-partial-refund-requested.event";

type OrderRefundRequestedEvent =
    | OrderFullRefundRequestedEvent
    | OrderPartialRefundRequestedEvent
    | OrderChangeRefundRequestedEvent;

const isOrderPaymentEvent = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    event: any,
): event is OrderRefundRequestedEvent => {
    return (
        isOrderFullRefundRequestedEvent(event) ||
        isOrderPartialRefundRequestedEvent(event) ||
        isOrderChangeRefundRequestedEvent(event)
    );
};

export { isOrderPaymentEvent };
export type { OrderRefundRequestedEvent };
